<form autocomplete="off" id="form" class="tw-h-full">
  <div class="tw-w-full">
    <fieldset
      [formThemeColor]="formsConfig()?.theme"
      [themeColorType]="'border'"
    >
      <legend [formThemeColor]="formsConfig()?.theme" [themeColorType]="'bg'">
        {{ "common.form" | translate }}
      </legend>

      <div class="tw-px-9 tw-pb-8">
        <!-- logo -->
        <div *ngIf="formsConfig()?.backgroundImagePath" class="tw-flex-center">
          <img [src]="imageUrl" alt="image" class="tw-w-72 tw-rounded-lg" />
        </div>

        <!-- title -->
        <div class="tw-text-center tw-my-5">
          <h1 class="tw-text-primary-800 dark:tw-text-gray-200">
            {{ formsConfig().title }}
          </h1>
        </div>

        <!-- description -->
        <div class="tw-py-3">
          <span
            [innerHtml]="formsConfig().description"
            class="tw-font-semibold tw-text-gray-600 dark:tw-text-white tw-text-lg"
          ></span>
        </div>

        <div class="row">
          @for (field of formsConfig().fields | orderBy : 'order'; track $index)
          {
          <!--todo remove condition after backend file type completes-->
          <div
            *ngIf="field.fieldType != formBuilderFieldTypes.File"
            [ngClass]="isModalMode ? 'sm:tw-w-1/2' : 'sm:tw-w-1/2 xl:tw-w-1/3'"
          >
            <form-generator-field
              [fieldValue]="field"
              [responses]="responses"
              (finalModel)="emitData($event)"
            >
            </form-generator-field>
          </div>
          }
        </div>
      </div>
    </fieldset>
  </div>

  <!-- form btns-->
  @if (!isModalMode) {
  <div class="tw-w-full tw-flex-end">
    <button
      (click)="onSubmit()"
      mat-ripple
      class="btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-mb-1 tw-h-16 tw-mt-6 tw-rounded-lg tw-w-72"
      [formThemeColor]="formsConfig()?.theme"
      [themeColorType]="'btn'"
      [type]="'button'"
    >
      @if (loading) {
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="sr-only">Loading...</span>
      } @else{
      <span> {{ "common.submit" | translate }}</span>
      }
    </button>
  </div>
  }
</form>
